import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-location",
  "use": "icon-location-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 16\" class=\"design-iconfont\" id=\"icon-location\">\n  <path d=\"M8,0 C11.31372,0 14,2.68628 14,6 C14,11.0074074 8.43621399,15.6438957 8.02408169,15.9804705 L8,16 C8,16 2,11.2 2,6 C2,2.68628 4.68628,0 8,0 Z M8,3.6 C6.67452,3.6 5.6,4.67452 5.6,6 C5.6,7.32548 6.67452,8.4 8,8.4 C9.32548,8.4 10.4,7.32548 10.4,6 C10.4,4.67452 9.32548,3.6 8,3.6 Z\" fill=\"#000\" fill-rule=\"nonzero\" transform=\"translate(-2)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol